import BGD2026 from "@assets/budget/B2026-logo.svg";
import ChevronImage from "@assets/video_widget/Chevron.webp";
import ArticleCard from "@blocks/Card/ArticleCard";
import GELiveBlog from "@components/Layouts/GeneralElection/GELiveBlog";
import Divider from "@elements/Divider/Divider";
import Heading from "@elements/Typography/Heading";
import { isArrayWithElements } from "@helper/utils";
import { BudgetWidgetProps } from "@typings/PagePayloadType";
import { ReactElement } from "react";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

type BudgetLiveBlogStyleProps = {
  wrapperStyle?: string;
};

export default function BudgetHomeWidget({
  budgetRecordedVideo,
  budgetTopStories,
  budgetLiveBlog,
}: BudgetWidgetProps): ReactElement {
  const title = "பட்ஜெட் 2026";

  const styles: BudgetLiveBlogStyleProps = {
    wrapperStyle: budgetRecordedVideo
      ? "max-h-[600px] w-full px-0 lg:min-h-[300px]"
      : "xl:w-[600px]",
  };

  const budgetLiveBlogStyle = budgetRecordedVideo
    ? "w-full lg:w-1/3 xl:w-1/4 lg:pr-5 order-second lg:order-first"
    : "w-full lg:w-1/2 xl:w-1/2 lg:pr-5 lg:order-first";
  const budgetArticleStyle = budgetRecordedVideo
    ? "w-full lg:w-full xl:w-1/4 order-last"
    : "w-full lg:w-1/2 xl:w-1/2 order-last";

  return (
    <div className="flex flex-col gap-xs bg-gray-500 mb-5 xl:mx-[-95px] xl:px-0 xl:w-[100% + 190px]">
      <div className="w-full h-2.5 bg-gradient-to-r from-pink-701 to-pink-301 xl:mb-5"></div>
      <div className="xl:max-w-xl w-full mx-auto xxs:px-sm xl:p-0 max-xsm:px-1 mb-10">
        <div className="">
          <img
            alt={title}
            height={36}
            width={106}
            className="absolute mt-5 md:mt-0 hidden md:block"
            src={BGD2026}
          />
          <div className="mb-5 md:mb-2.5">
            <Heading
              Element="h1"
              className={twMerge(
                "inline font-bold font-primary text-2.5md leading-9 mb-5 md:pl-28",
              )}
            >
              {title}
            </Heading>
            <div className="ml-2.5 md:pl-12 inline float-right mt-2 md:mt-4">
              <Link
                reloadDocument
                to={`/keywords/budget2026?ref=budget-home`}
                target="_blank"
                className="text-pink-200 font-bold text-sm leading-6"
              >
                மேலும் படிக்க
                <img
                  alt="toggle-button-chevie"
                  height={28}
                  width={28}
                  className="pl-[5px] inline"
                  src={ChevronImage}
                />
              </Link>
            </div>
          </div>
          <Divider className="border-b border-gray-2200 mb-5" />
        </div>

        <div className="flex flex-wrap">
          {budgetLiveBlog && (
            <div className={budgetLiveBlogStyle}>
              <GELiveBlog
                variant="sidebar"
                geLiveBlogContent={budgetLiveBlog}
                styles={styles}
              />
            </div>
          )}
          {budgetRecordedVideo && (
            <div className="w-full xl:w-1/2 lg:w-2/3 xl:pr-5 ge-youtube-video-home mb-380 xl:mb-0 order-first lg:order-second">
              <div dangerouslySetInnerHTML={{ __html: budgetRecordedVideo }} />
            </div>
          )}
          <div className={budgetArticleStyle}>
            {isArrayWithElements(budgetTopStories) ? (
              <>
                <div className="text-sm font-medium font-secondary leading-6 pb-2.5">
                  பட்ஜெட் 2026 செய்திகள்
                </div>
                {budgetTopStories.map((article, i, row) => (
                  <ArticleCard
                    displayWidth={135}
                    displayHeight={90}
                    key={article.id}
                    elements={{ hasParagraph: false, hasDate: true }}
                    overrideStyle={{
                      cardWrapper: twMerge(
                        "flex-row",
                        i + 1 === row.length
                          ? "border-b-0 pb-0"
                          : "border-b-gray-2050",
                        i === 0 && "pt-0",
                      ),
                      titleStyle:
                        "font-semibold font-primary text-2sm text-gray-100 hover:text-gray-100",
                      imageWrapperStyle: "hidden",
                      contentWrapper: "gap-xs",
                      titleWrapper: "gap-0",
                      imageStyle: "w-full h-23",
                    }}
                    refMedium="home_budget_top_stories"
                    {...article}
                  />
                ))}
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
